import { ExclamationCircleIcon } from '@heroicons/react/solid'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { pathOr } from 'ramda'

import capitalize from '@/utils/capitalize'

const Input = ({ register, errors, name, label, className, ...props }) => {
  const error = pathOr('', [name, 'message'])(errors)
  const router = useRouter()

  return (
    <div className='w-full'>
      <label
        className={classNames(
          router.pathname === '/contact'
            ? 'get-in-touch-font block flex items-end text-sm text-gray-700'
            : 'block flex items-end text-sm font-medium text-gray-700',
        )}
      >
        <span className='mr-0.5 whitespace-nowrap py-[3.5px]'>{label}</span>
        <div className='relative mt-1 w-full'>
          <span className='absolute inset-x-0 bottom-0 -translate-y-2.5 border-b border-dotted border-b-gray-900' />
          <input
            name={name}
            {...props}
            className={classNames(
              `block w-full appearance-none border-transparent bg-transparent px-3 py-0.5 text-sm placeholder-gray-400  focus:border-theme-blue focus:outline-none focus:ring-theme-blue`,
              error
                ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500'
                : '',
              className,
            )}
            {...register(name)}
          />
          {Boolean(error) && (
            <div className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3'>
              <ExclamationCircleIcon
                className='h-5 w-5 text-red-500'
                aria-hidden='true'
              />
            </div>
          )}
        </div>
      </label>
      <p className='mt-2 text-sm text-red-600'>{capitalize(error)}</p>
      <style jsx>{`
        .get-in-touch-font {
          font-weight: 200;
          font-size: 35pt;
          line-height: 92pt;
        }
        @media (max-width: 1920px) {
          .get-in-touch-font {
            font-weight: 200;
            font-size: calc(11pt + (35 - 11) * (100vw - 360px) / (1920 - 360));
            line-height: calc(
              23pt + (92 - 23) * (100vw - 360px) / (1920 - 360)
            );
          }
        }
      `}</style>
    </div>
  )
}

export default Input

Input.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.object.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
}

Input.defaultProps = {
  className: '',
  label: '',
}
